__turbopack_context__.v({
  "answer": "InsightQAAnswer-module__YDMw7q__answer",
  "attributions": "InsightQAAnswer-module__YDMw7q__attributions" + " " + "cds-hstack",
});
